import React from 'react';
import { facebook, instagram, logoFooter, numVentasPrincipal, numVentasSecundario, portalClientes, portalTutores, tikotk, youtube } from '../config/constant';
import { constructorWhatsapp } from '../utils/utils';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-400 py-12 px-6 lg:px-16 border-t border-slate-900 font-sans">
      
      {/* GRILLA PRINCIPAL DE 4 COLUMNAS */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 items-start text-center sm:text-left">
        
        {/* COLUMNA 1: IMAGEN DEL SERVICIO / PLATAFORMAS */}
        <div className="flex flex-col items-center sm:items-start gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">
            Soporte Académico Global
          </h3>
          <div className="w-full max-w-[240px] bg-slate-900 border border-slate-800/80 rounded-xl aspect-[16/9] flex items-center justify-center overflow-hidden group">
            <img 
              src={logoFooter} 
              alt="Plataformas y servicios soportados"
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `
                  <div class="p-4 text-center text-xs text-slate-500 font-medium">
                    Espacio reservado para tu foto<br/>(Manejo de Plataformas / Universidad)
                  </div>
                `;
              }}
            />
          </div>
          <p className="text-xs text-slate-500 leading-relaxed max-w-[240px]">
            #Nosotros lo hacemos por ti.
          </p>
        </div>

        {/* COLUMNA 2: ACCESOS DIRECTOS (NUEVA SECCIÓN REUTILIZABLE) */}
        <div className="flex flex-col items-center sm:items-start gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">
            Accesos Directos
          </h3>
          <div className="flex flex-col gap-3 text-xs md:text-sm font-medium w-full">
            <Link 
              to={portalClientes}
              className="hover:text-white transition-colors flex items-center justify-center sm:justify-start gap-2 group"
            >
              <span className="w-1.5 h-1.5 bg-blue-500 rounded-full group-hover:scale-125 transition-transform" />
              Portal Clientes
            </Link>
            <Link 
              to={portalTutores}
              className="hover:text-white transition-colors flex items-center justify-center sm:justify-start gap-2 group"
            >
              <span className="w-1.5 h-1.5 bg-purple-500 rounded-full group-hover:scale-125 transition-transform" />
              Soy Tutor
            </Link>
          </div>
        </div>

        {/* COLUMNA 3: LÍNEAS DE VENTAS (WHATSAPP - CORREGIDO) */}
        <div className="flex flex-col items-center sm:items-start gap-4">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">
            Líneas de Atención
          </h3>
          <div className="flex flex-col gap-2.5 w-full max-w-[240px] mx-auto sm:mx-0">
            {/* Línea de Ventas 1 */}
            <a 
              href={constructorWhatsapp(numVentasPrincipal, 'Hola, deseo cotizar un servicio')}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 bg-slate-900/50 hover:bg-slate-900 border border-slate-800/60 hover:border-slate-700 rounded-xl transition-all group"
            >
              <div className="w-8 h-8 rounded-lg bg-emerald-500/10 text-emerald-400 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.713-1.457L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.63-1.023-5.101-2.887-6.968a9.82 9.82 0 0 0-6.972-2.883c-5.433 0-9.854 4.417-9.858 9.848-.002 1.748.465 3.455 1.35 4.98L1.945 22.1l4.702-1.233z"/>
                </svg>
              </div>
              <div className="text-left">
                <span className="text-[10px] uppercase font-bold text-slate-500 block">Canal Principal</span>
                <span className="text-sm font-bold text-slate-300 group-hover:text-white transition-colors">Línea de Ventas 1</span>
              </div>
            </a>

            {/* Línea de Ventas 2 */}
            <a 
              href={constructorWhatsapp(numVentasSecundario, 'Hola, deseo cotizar un servicio')}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 bg-slate-900/50 hover:bg-slate-900 border border-slate-800/60 hover:border-slate-700 rounded-xl transition-all group"
            >
              <div className="w-8 h-8 rounded-lg bg-emerald-500/10 text-emerald-400 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.713-1.457L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.63-1.023-5.101-2.887-6.968a9.82 9.82 0 0 0-6.972-2.883c-5.433 0-9.854 4.417-9.858 9.848-.002 1.748.465 3.455 1.35 4.98L1.945 22.1l4.702-1.233z"/>
                </svg>
              </div>
              <div className="text-left">
                <span className="text-[10px] uppercase font-bold text-slate-500 block">Canal Alterno</span>
                <span className="text-sm font-bold text-slate-300 group-hover:text-white transition-colors">Línea de Ventas 2</span>
              </div>
            </a>
          </div>
        </div>

        {/* COLUMNA 4: CORREOS Y REDES SOCIALES */}
        <div className="flex flex-col items-center sm:items-start gap-5">
          <h3 className="text-white font-bold text-sm uppercase tracking-wider">
            Contacto y Redes
          </h3>
          <div className="flex flex-col gap-1.5 text-xs md:text-sm font-medium">
            <a href="mailto:asesorandres@dufyasesorias.com" className="hover:text-white transition-colors block">
              asesorandres@dufyasesorias.com
            </a>
            <a href="mailto:dufyasesorias@gmail.com" className="hover:text-white transition-colors block text-slate-500">
              dufyasesorias@gmail.com
            </a>
          </div>

          {/* Redes Sociales */}
          <div className="flex items-center gap-3.5 pt-1">
            <a href={facebook} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-blue-600 hover:border-blue-500 transition-all shadow-sm" aria-label="Facebook">
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a href={instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-pink-600 hover:border-pink-500 transition-all shadow-sm" aria-label="Instagram">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01" />
              </svg>
            </a>
            <a href={youtube} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-red-600 hover:border-red-500 transition-all shadow-sm" aria-label="YouTube">
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                <path d="M23.498 6.163a3.003 3.003 0 00-2.11-2.11C19.517 3.545 12 3.545 12 3.545s-7.517 0-9.388.508a3.003 3.003 0 00-2.11 2.11C0 8.033 0 12 0 12s0 3.967.502 5.837a3.003 3.003 0 002.11 2.11c1.871.507 9.388.507 9.388.507s7.517 0 9.388-.507a3.003 3.003 0 002.11-2.11C24 15.967 24 12 24 12s0-3.967-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a href={tikotk} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-xl bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:bg-slate-800 hover:border-slate-700 transition-all shadow-sm" aria-label="TikTok">
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.03 1.6 4.25a7.117 7.117 0 003.42 2.14c0 1.32-.01 2.64 0 3.95a10.87 10.87 0 01-5.18-2.1c-.05 2.58-.02 5.15-.04 7.73a6.832 6.832 0 01-2.43 4.96c-3.16 2.6-7.98 2.06-10.49-1.2A6.745 6.745 0 014.2 14.93c.18-4.32 3.95-7.7 8.28-7.39.03 1.35 0 2.69.01 4.04a3.155 3.155 0 00-2.3 3.42c.2 1.83 1.87 3.03 3.69 2.72a3.14 3.14 0 002.57-3.1c.02-4.88.01-9.76.01-14.63h.065z" />
              </svg>
            </a>
          </div>
        </div>

      </div>

      {/* RECUADRO INFERIOR DE DERECHOS DE AUTOR Y ENLACES LEGALES ENLACE-LINK */}
      <div className="max-w-6xl mx-auto border-t border-slate-900 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center text-xs md:text-sm">
        <p className="text-slate-500 font-medium">
          &copy; {currentYear} Dufy Asesorías. Todos los derechos reservados.
        </p>
        
        <div className="flex gap-4 font-semibold">
          <Link 
            to="/politica-privacidad" 
            className="hover:text-white text-slate-500 transition-colors"
          >
            Política de Privacidad
          </Link>
          <span className="text-slate-800 select-none">|</span>
          <Link 
            to="/terminos-y-condiciones" 
            className="hover:text-white text-slate-500 transition-colors"
          >
            Términos de Servicio
          </Link>
        </div>
      </div>

    </footer>
  );
};

export default Footer;